"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facade = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var Facade = function (props) {
    var radius = 45;
    var topGap = radius + 3;
    var circleGap = 10;
    var rightGap = 15;
    var path = '';
    // Begin at this x,y position
    path += "M0," + topGap;
    // Draw a horizontal line to 125px from right
    path += " L" + (props.width - (rightGap + circleGap + radius + radius + circleGap)) + "," + topGap;
    // Draw a relative arc 110px wide (width of circle + left/right spacing)
    path += " a1,1,0,0,0," + (circleGap + radius + radius + circleGap) + ",0";
    // Draw a horizontal line to the right edge
    path += " L" + props.width + "," + topGap;
    // Draw a vertical line down to the bottom right corner
    path += " L" + props.width + "," + props.height;
    // Draw a horizontal line to the bottom left corner
    path += " L0," + props.height;
    // Close polygon by connecting back to the start
    path += ' Z';
    var iconContainerStyles = {
        height: props.icon.height,
        // The Top/Right attributes are used for centering the icon over the center of the circle
        right: (rightGap + circleGap + radius) - (props.icon.width / 2) + "px",
        top: topGap - (props.icon.height / 2) + 0 + "px",
        width: props.icon.width,
    };
    return (React.createElement("div", { className: "position-relative", style: { width: props.width } },
        React.createElement("svg", { width: props.width, height: props.height, "aria-hidden": "true", className: "modal-facade" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none" },
                React.createElement("circle", { fill: honeycomb_1.Styles.Colors.Aliases.backgroundLight, cx: props.width - (rightGap + circleGap + radius), cy: topGap, r: radius }),
                React.createElement("path", { fill: honeycomb_1.Styles.Colors.Aliases.backgroundLight, d: path }))),
        props.icon && (React.createElement("div", { className: "dialogue-icon", style: iconContainerStyles }, props.icon.element))));
};
exports.Facade = Facade;
exports.Facade.defaultProps = {
    height: 300,
    width: 600,
};
exports.Facade.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
};
